export const REFRESH_TOKEN_KEY = 'livable_refresh_notification';
export const NOTIFICATION_DEFAULT = {
  title: '',
  body: 'Notification body text',
  buttonTitle: 'Show me!',
  buttonLink: '/active_dashboard'
};